import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeFi from '@angular/common/locales/fi';
import { AppOAuthStorage } from '@headpower/angular-oauth2-oidc-extensions';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ThemeService, getOldTheme } from '@headpower/layout';
import '@headpower/components/dayjs-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CatalogModule } from './modules/catalog/catalog.module';
import { CoreModule } from './modules/core/core.module';
import { InstructionModule } from './modules/instruction/instruction.module';
import { SharedModule } from './modules/shared/shared.module';
import { TagModule } from './modules/tag/tag.module';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { HpoErrorHandler } from './shared/handlers/hpo-errorhandler.service';
import { environment } from 'src/environments/environment';
import { FileModule } from './modules/file/file.module';
import { AuthModule } from './auth/auth.module';

export function createOAuthStorage() {
    return new AppOAuthStorage('headpower_web_app', 'iwi');
}

export function initTheme(themeService: ThemeService): Function {
    return () => themeService.init(getOldTheme());
}

registerLocaleData(localeFi, 'fi-FI');

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        OAuthModule.forRoot(),
        CoreModule,
        SharedModule,
        InstructionModule,
        CatalogModule,
        TagModule,
        FileModule,
        AuthModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production
        })
    ],
    providers: [
        { provide: OAuthStorage, useFactory: createOAuthStorage },
        { provide: AppOAuthStorage, useFactory: createOAuthStorage },
        { provide: ErrorHandler, useClass: HpoErrorHandler },
        { provide: APP_INITIALIZER, useFactory: initTheme, deps: [ThemeService], multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
